module.exports = __webpack_public_path__ + "static/media/mundo_thumb.9f32285e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/mundo_thumb.png
// module id = 171
// module chunks = 0